module.exports = __webpack_public_path__ + "img/gwyx-ekx.e11407f1.png";